<template>
  <div>
    <Navbar activeDirectory="storico" activePage="lavori"></Navbar>
    <div class="container-fluid">
      <div class="row" v-if="lavoro.deleted">
        <div class="col">
          <div
            class="alert alert-danger"
          >Questo lavoro è stato eliminato, pertanto non è presente nei report e nelle statistiche. <button class="btn btn-success btn-sm btn-danger ml-2" @click="confirmReopen()">Ripristina lavoro</button></div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card">
            <h4 class="card-header font-bold text-uppercase">
              <small>Intervento,</small>
              {{ lavoro.intervento }}
              <small>presso</small>
              {{ lavoro.strada }}
            </h4>
            <div class="card-body">
              <form type="multipart/form-data" ref="editForm" @submit.prevent="confirmNewRevision">
                <table class="table table-striped border">
                  <tbody>
                    <tr>
                      <th>Intervento</th>
                      <td>
                        <select
                          style="width: 100%; border: 0; background: transparent; font-weight: 600;"
                          name="intervento"
                          v-model="lavoro.intervento"
                        >
                          <option value="buca">BUCA</option>
                          <option value="sfalcio">SFALCIO</option>
                          <option value="segnaletica">SEGNALETICA</option>
                          <option value="pulizia">PULIZIA</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>Revisione</th>
                      <td class="text-left" v-if="lavoro.version>0">Revisione n.{{ lavoro.version }}</td>
                      <td class="text-left" v-else>Versione originale</td>
                    </tr>
                    <tr>
                      <th>Team</th>
                      <td class="text-left">{{ lavoro.team.nome }}</td>
                    </tr>
                    <tr>
                      <th>Avviato in data</th>
                      <td class="text-left">{{ formatTimestampToLocalDate(lavoro.inizio.tempo) }}</td>
                    </tr>
                    <tr v-if="lavoro.fine.tempo">
                      <th>Concluso in data</th>
                      <td class="text-left">{{ formatTimestampToLocalDate(lavoro.fine.tempo) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td class="text-left">{{ lavoro.strada }}</td>
                    </tr>
                    <tr v-if="lavoro.inizio.latitudine">
                      <th>Inizio (Lat, Lon)</th>
                      <td
                        class="text-left"
                      >({{ lavoro.inizio.latitudine }}, {{ lavoro.inizio.longitudine }})</td>
                    </tr>
                    <tr v-if="lavoro.fine.latitudine">
                      <th>Fine (Lat, Lon)</th>
                      <td
                        class="text-left"
                      >({{ lavoro.fine.latitudine }}, {{ lavoro.fine.longitudine }})</td>
                    </tr>
                    <tr v-if="lavoro.distanza">
                      <th>Distanza (metri)</th>
                      <td>
                        <input
                          style="width: 100%; border: 0; background: transparent; font-weight: 600;"
                          name="distanza"
                          v-model="lavoro.distanza"
                          type="number"
                        />
                      </td>
                    </tr>
                    <tr v-if="lavoro.distanza">
                      <th>Distanza lineare misurata (metri)</th>
                      <td
                        class="text-left"
                      >{{ lavoro.distanza_misurata ? lavoro.distanza_misurata : 0 }}</td>
                    </tr>
                    <tr v-if="lavoro.numero_buche">
                      <th>Buche riparate</th>
                      <td>
                        <input
                          style="width: 100%; border: 0; background: transparent; font-weight: 600;"
                          name="buche"
                          v-model="lavoro.numero_buche"
                          type="number"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <img
                          :src="lavoro.inizio.foto"
                          style="max-height: 360px; max-width: 100%; cursor: pointer;"
                          @click="showFotoInizioUploader=!showFotoInizioUploader;"
                          v-if="!showFotoInizioUploader"
                        />
                        <br />
                        <span class="badge badge-primary">Inizio</span>
                        <i
                          class="fa fa-pencil ml-2"
                          @click="showFotoInizioUploader=!showFotoInizioUploader;"
                          style="cursor: pointer;"
                        ></i>
                        <br v-if="showFotoInizioUploader" />
                        <input
                          v-if="showFotoInizioUploader"
                          @change="processFoto($event, 'inizio')"
                          type="file"
                        />
                      </td>
                      <td>
                        <img
                          :src="lavoro.fine.foto"
                          style="max-height: 360px; max-width: 100%; cursor: pointer;"
                          @click="showFotoFineUploader=!showFotoFineUploader;"
                          v-if="!showFotoFineUploader"
                        />
                        <br />
                        <span class="badge badge-secondary">Fine</span>
                        <i
                          class="fa fa-pencil ml-2"
                          @click="showFotoFineUploader=!showFotoFineUploader;"
                          style="cursor: pointer;"
                        ></i>
                        <br v-if="showFotoFineUploader" />
                        <input
                          v-if="showFotoFineUploader"
                          @change="processFoto($event, 'fine')"
                          type="file"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
              <br />
              <button class="btn btn-primary" @click="confirmNewRevision()" v-if="!lavoro.deleted && lavoro.fine.tempo">Nuova revisione</button>
              <button
                class="btn btn-danger ml-2"
                @click="confirmDeletion()"
                v-if="!lavoro.deleted"
              >Elimina lavoro</button>
              
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <h4 class="card-header font-bold text-uppercase">
              <small>Storico delle</small> revisioni
            </h4>
            <div class="card-body">
              <table class="table table-hover border">
                <thead class="thead-light">
                  <th>Revisione n.</th>
                  <th>Revisore</th>
                  <th>Data</th>
                </thead>
                <tbody>
                  <tr
                    v-for="item in revisioni"
                    v-bind:key="item.id"
                    style="cursor: pointer;"
                    :class="[{'bg-secondary text-white font-bold':revisioneSelected==item.version}]"
                    @click="lavoro=JSON.parse(JSON.stringify(item));showFotoInizioUploader=false;showFotoFineUploader=false;revisioneSelected=item.version;"
                  >
                    <td v-if="item.version > 0">Revisione n. {{ item.version }}</td>
                    <td v-else>Versione originale</td>
                    <td v-if="item.version > 0">{{ item.editor.nome }}</td>
                    <td v-else>-</td>
                    <td v-if="item.version > 0">{{ formatTimestampToLocalDate(item.update_time) }}</td>
                    <td v-else>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      lavoro: {
        team: {},
        inizio: {},
        fine: {},
      },
      revisioni: [],
      revisioneSelected: 0,
      ultimaRevisione: 0,
      showFotoInizioUploader: false,
      showFotoFineUploader: false,
      fotoInizio: null,
      fotoFine: null,
    };
  },

  mounted() {
    if (localStorage.getItem("tipologia") != "B") {
      this.$router.push({ name: "home" });
    }

    this.fetchData();
  },

  methods: {
    fetchData() {
      this.axios
        .get(`dockyard/${this.$route.params.uuid}/versions`)
        .then((response) => {
          this.revisioni = response.data;
          this.lavoro = response.data[0];
          this.revisioneSelected = this.lavoro.version;
          this.ultimaRevisione = this.lavoro.version;
        });
    },

    // confirmNewRevision
    //
    // Use sweet-alert to confirm
    confirmNewRevision() {
      if(this.lavoro.deleted && this.lavoro.fine.tempo) {
        return
      }
      this.$swal
        .fire({
          title: "Nuova revisione",
          text: "Procedendo verrà creata una nuova revisione per questo lavoro",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, genera",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("version", this.ultimaRevisione);
            formData.append("intervento", this.lavoro.intervento);
            formData.append("distanza", this.lavoro.distanza);
            formData.append("numero_buche", this.lavoro.numero_buche);
            formData.append("foto_inizio", this.fotoInizio);
            formData.append("foto_fine", this.fotoFine);
            this.axios
              .put(`dockyard/${this.$route.params.uuid}/versions`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // confirmDeletion
    //
    // Use sweet-alert to confirm
    confirmDeletion() {
      this.$swal
        .fire({
          title: "Elimina lavoro",
          text:
            "Procedendo verrà eliminato questo lavoro che non sarà più presente nei report",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, elimina",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("del_status", "true");
            this.axios
              .put(`dockyard/${this.$route.params.uuid}/delete`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // confirmReopen
    //
    // Use sweet-alert to confirm
    confirmReopen() {
      this.$swal
        .fire({
          title: "Ripristina lavoro",
          text:
            "Procedendo verrà ripristinato questo lavoro che sarà nuovamente presente nei report",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, ripristina",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("del_status", "false");
            this.axios
              .put(`dockyard/${this.$route.params.uuid}/delete`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // processFoto
    //
    // Used for upload image
    processFoto(event, type) {
      var target = event.target.files[0];
      if (type == "fine") {
        this.fotoFine = target;
      } else {
        this.fotoInizio = target;
      }
    },

    // Classe Intervento
    // Individua la classe di badge
    // in base all'intervento
    classeInterventoBadge(intervento) {
      if (intervento == "buca") {
        return "badge-success";
      }
      if (intervento == "sfalcio") {
        return "badge-primary";
      }
      if (intervento == "segnaletica") {
        return "badge-dark";
      }
      if (intervento == "rifiuto") {
        return "badge-warning";
      }
      if (intervento == "rifiuto_speciale") {
        return "badge-purple";
      }
      if (intervento == "emergenza_carreggiata") {
        return "badge-danger";
      }
      if (intervento == "pulizia") {
        return "badge-secondary";
      }
    },

    // Format Timestamp to Local Date
    formatTimestampToLocalDate(ts) {
      if (ts) {
        const today = new Date();
        var tsDate = new Date(ts * 1000);
        if (
          today.getDate() == tsDate.getDate() &&
          today.getMonth() == tsDate.getMonth() &&
          today.getFullYear() == tsDate.getFullYear()
        ) {
          return `Oggi, ${tsDate.toLocaleTimeString()}`;
        } else {
          return tsDate.toLocaleString();
        }
      } else {
        return "-";
      }
    },
  },
};
</script>

<style>
td {
  text-align: center;
  vertical-align: middle;
}
</style>